<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-striped table-borderless caption-top">
        <thead>
        <tr>
          <th scope="col" class="text-center align-middle" nowrap>ลำดับ</th>
          <th scope="col" class="text-center align-middle" nowrap>รหัส</th>
          <th scope="col" class="text-center align-middle" nowrap>เขต/ส่วนกลาง</th>
          <th scope="col" class="text-center align-middle" nowrap>Email</th>
          <th scope="col" class="text-center align-middle" nowrap>จัดการข้อมูล</th>
        </tr>
        </thead>
        <tbody>
          @for (item of items; let i = $index; track item.code) {
            <tr>
              <td class="text-center">{{ i + 1 }}</td>
              <td class="text-center">{{ item.code }}</td>
              <td>{{ item.name }}</td>
              <td>
                <div class="row" *ngFor="let email of item?.emails; let j= index; let last = last;">
                  <div class="col-auto">
                    <p class="fw-normal mb-2">{{email}}</p>
                  </div>
                </div>
              </td>
              <td class="text-center">
                <button type="button" (click)="manageEmailModal(item)" class="btn btn-outline-secondary me-3">
                  <i class="bi bi-pencil-fill"></i>
                </button>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="5">
                <app-not-found></app-not-found>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>
